import React, { createContext, ReactNode, useState } from 'react'

// Definindo a interface para os dados do formulário
export interface FormData {
  email: string
  reward: number
  newEmployee: boolean
  name?: string
}

// Definindo a interface para o contexto do formulário
interface FormContextType {
  steps: FormData[]
  currentStep: number
  addStep: (email: string, reward: number, newEmployee: boolean) => void
  updateStep: (index: number, data: FormData) => void
  setCurrentStep: (step: number) => void
  setSteps: (step: FormData[]) => void
}

// Criando o contexto com um valor padrão
const FormContext = createContext<FormContextType | undefined>(undefined)

interface FormProviderProps {
  children: ReactNode
}

export const RewardFormProvider: React.FC<FormProviderProps> = ({
  children,
}) => {
  const [steps, setSteps] = useState<FormData[]>([])
  const [currentStep, setCurrentStep] = useState(0)

  const addStep = (email: string, reward: number, newEmployee: boolean) => {
    const newStep = { email, reward, newEmployee }
    setSteps([...steps, newStep])
  }

  const updateStep = (index: number, data: FormData) => {
    const newSteps = steps.slice()
    newSteps[index] = data
    setSteps(newSteps)
  }

  return (
    <FormContext.Provider
      value={{
        steps,
        currentStep,
        addStep,
        updateStep,
        setCurrentStep,
        setSteps,
      }}
    >
      {children}
    </FormContext.Provider>
  )
}

export { FormContext }
